import type { CampaignV2Template } from '@/services/endpoints/campaigns/types';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { HiOutlineDocumentText } from 'react-icons/hi';
import { twMerge } from 'tailwind-merge';

type CampaignTemplateCalloutProps = {
  template?: CampaignV2Template;
  /** i18n key under campaign namespace, e.g. whatsappCampaignDetails.template */
  labelKey: string;
  emptyValue?: string;
  className?: string;
};

/** Prominent, display-only template name (no navigation — templates cannot be fetched by id). */
export const CampaignTemplateCallout: FC<CampaignTemplateCalloutProps> = ({
  template,
  labelKey,
  emptyValue = '—',
  className,
}) => {
  const { t } = useTranslation('campaign');

  return (
    <div
      className={twMerge(
        'flex items-start gap-3 rounded-2xl border border-brand-200 bg-brand-50 px-4 py-3',
        className
      )}
    >
      <span className='mt-0.5 inline-flex shrink-0 rounded-xl border border-brand-200 bg-white-100 p-2 text-brand-700'>
        <HiOutlineDocumentText className='size-5' aria-hidden />
      </span>
      <div className='min-w-0 flex flex-col gap-0.5'>
        <p className='text-xs font-semibold uppercase tracking-[0.12em] text-brand-700'>{t(labelKey)}</p>
        <p className='truncate text-base font-semibold text-brand-900'>{template?.name || emptyValue}</p>
      </div>
    </div>
  );
};
